var map = {
	"./Bzhan.svg": 66533,
	"./add.svg": 59614,
	"./android.svg": 9357,
	"./axdianzan.svg": 58469,
	"./axsxdianzan.svg": 91043,
	"./charRoom.svg": 44819,
	"./chrome.svg": 88733,
	"./close.svg": 93318,
	"./copyright.svg": 67645,
	"./deep.svg": 19143,
	"./edge.svg": 29753,
	"./email.svg": 51533,
	"./empty.svg": 22025,
	"./gitee.svg": 35167,
	"./github.svg": 89460,
	"./link.svg": 14121,
	"./mac.svg": 68926,
	"./qq.svg": 56869,
	"./qqgroup.svg": 3415,
	"./safari.svg": 55943,
	"./shallow.svg": 3957,
	"./tag.svg": 64205,
	"./topBar.svg": 24838,
	"./wechat.svg": 70267,
	"./weibo.svg": 19248,
	"./windowns.svg": 54136,
	"./xkxy.svg": 74377,
	"./zanzhu.svg": 24139,
	"./zhihu.svg": 26908
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;